<div>
  <mat-label>{{title}}</mat-label>
</div><br>
<form #form="ngForm">
  <mat-form-field class="input-margin" style="width: 40%; margin-right: 10%">
    <mat-label>
      開始日齢
    </mat-label>
    <input matInput required placeholder="開始日齢" type="number" min="1"
           name="startNichirei" [(ngModel)]="meisai.startNichirei" (ngModelChange)="nichireiToShuurei(meisai.startNichirei, 'start')">
  </mat-form-field>

  <mat-form-field class="input-margin" style="width: 40%">
    <mat-label>
      終了日齢
    </mat-label>
    <input matInput required placeholder="終了日齢" type="number" min="1"
           name="endNichirei" [(ngModel)]="meisai.endNichirei" (ngModelChange)="nichireiToShuurei(meisai.endNichirei, 'end')">
  </mat-form-field>

  <mat-form-field class="input-margin" style="width: 40%; margin-right: 10%">
    <mat-label>
      開始週齢
    </mat-label>
    <input matInput placeholder="開始週齢"
           name="startShuurei" [(ngModel)]="startShuurei" (ngModelChange)="shuureiToNichirei(startShuurei, 'start')">
  </mat-form-field>

  <mat-form-field class="input-margin" style="width: 40%">
    <mat-label>
      終了週齢
    </mat-label>
    <input matInput placeholder="終了週齢"
           name="endShuurei" [(ngModel)]="endShuurei" (ngModelChange)="shuureiToNichirei(endShuurei, 'end')">
  </mat-form-field>

  <mat-form-field class="input-margin" style="width: 40%; margin-right: 10%">
    <mat-label>
      点灯時刻
    </mat-label>
    <input matInput required placeholder="点灯時刻" type="time"
           name="tentouShoutouJikoku[0].start" [(ngModel)]="meisai.tentouShoutouJikoku[0]['start']" (ngModelChange)="genTentouJikan()">
  </mat-form-field>

  <mat-form-field class="input-margin" style="width: 40%">
    <mat-label>
      消灯時刻
    </mat-label>
    <input matInput required placeholder="消灯時刻" type="time"
           name="tentouShoutouJikoku[0].end" [(ngModel)]="meisai.tentouShoutouJikoku[0]['end']" (ngModelChange)="genTentouJikan()">
  </mat-form-field>

  <mat-form-field class="input-margin" style="width: 90%">
    <mat-label>
      点灯時間
    </mat-label>
    <input matInput placeholder="点灯時間" type="time"
           name="tentouJikan" [(ngModel)]="tentouJikan"
           (ngModelChange)="commonService.refTentouJikanInShoutouJikoku(meisai, tentouJikan)">
  </mat-form-field>
</form>
<div mat-dialog-actions align="end">
  <button mat-button mat-flat-button color="primary" (click)="commonService.onClick(this.matDialogRef, meisai)" [disabled]="form.invalid || !form.dirty">
    <span>Enter</span>
  </button>
</div>
